import React, { CSSProperties } from "react";

import "./styles.scss"

export interface TabContentProps {
  label?: React.ReactNode;
  currentTabName?: string;
  className?: string;
  name: string;
  visible?: boolean;
}

const sytle: CSSProperties = {
  paddingBottom: "10px",
}

const TabContent: React.FC<TabContentProps> = ({
  label,
  className = "",
  name,
  currentTabName,
  children,
  visible = true,
}) => {
  let ocultar = name !== currentTabName;

  if (!ocultar && !visible) {
    ocultar = true;
  }

  return <div className={`TabContent ${className}`} hidden={ocultar} style={sytle}>{children}</div>;
};

export { TabContent };
